import { render, staticRenderFns } from "./EfoMappingTable.vue?vue&type=template&id=201004dc&"
import script from "./EfoMappingTable.vue?vue&type=script&lang=ts&"
export * from "./EfoMappingTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports